import React from 'react';

export default function PreviewFormatter(props) {
    return <div></div>;
}
